import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import type { RouterContext } from "@/router";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <TooltipProvider delayDuration={300}>
      <Outlet />
      <Toaster position="bottom-right" closeButton richColors />
    </TooltipProvider>
  ),
  notFoundComponent: () => (
    <div className="flex h-screen items-center justify-center text-muted-foreground">Page not found.</div>
  ),
});
